const editModal = document.querySelector('#edit-folder-modal');
if (editModal) {
    const fieldId = document.querySelector('#folder-id');
    const fieldName = document.querySelector('#edit-folder');
    editModal.addEventListener('show.bs.modal', function (event) {
        let trigger = event.relatedTarget;

        fieldId.value = trigger.getAttribute('data-bs-id');

        fieldName.value = '';
    })
}

const share_modal = document.querySelector('#share-folder-modal');
if (share_modal) {
    share_modal.addEventListener('click', (e) => {
        if (e.target.closest('button.clipboard-link')) {
            let input = share_modal.querySelector('#catalog-url-input');
            input.select();
            input.setSelectionRange(0, 99999);

            document.execCommand('copy');
        }
    });
}
